module.exports = __webpack_public_path__ + "img/其他系统.72bdadaa.svg";